import moment from 'moment';

/* eslint-disable max-len */
const regexes = {
  sortCode: /^([0-9]{6})$/,
  accountNo: /^([0-9]{8})$/,
  companyRegistrationNumber: /^(SC|sc|sC|Sc|OC|oc|oC|Oc|SO|so|sO|So)\d{6}$|[0-9]{8}$/,
  numberWithoutZero: /^([1-9][0-9]*)$/,
  alphanumeric: /^((^[a-z]{2}\.\s)?((\w|\w')\s[a-z]{2}\.\s)?([a-z0-9]+-[a-z0-9]+)?([0-9]\/[0-9]{0,2})?([a-z]{1}'[a-z]+|\s[a-z]{1}'[a-z]+|[a-z]'\s[a-z]+|[a-z]'[s]\s[a-z]+)*([a-z0-9]+\s{0,1})?)+(\w{2,}'|[\w]|\w{2,}'[s])$/i,
  alphanumericPunctuationSpace: /^([a-z0-9\-_, ./£$?!&:]*)$/i,
  alphanumericSpaceBusinessActivities: /^([a-z0-9\-_, '%*()./£$?!&:]*)$/i,
  alphanumericSpace: /^([a-z0-9\-_, .$!&:]*)$/i,
  email: /^([-a-z0-9!$%&*_/=+#}{'?|]+(\.[-a-z0-9!$%&*_/=+#}{'?|]+)*)@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]+)$/i,
  tel: /^[0-9]{11}$/,
  mobile: /^(07[\d]{9})$/,
  date: /^((3[01]{1}|[012]{1}[0-9]{1})-((0[1-9]{1}|1[012]{1})))-(((19|18)[0-9]{2}|2[0-9]{3}))$/i,
  postcode: /^((GIR 0AA|X9 9RB|X9 9AA|X9 9BF|X9 9AJ|X9 9AB|X9 9TA|X9 9LG|X9 9BH|X9 9LF|X9 2TR|XE16 4QZ|XE11 1AA|XE98 1TL|XEP O11|XE99 3GG|XE0 2AQ|XE1A 1AA|XE18 3AN|XE7 4GJ|XE1P 2PR|XE2 7EJ|XE12 8JS|XE1H 9DW|XE 5GG|XE1X 7XA|XE1X 7XF|XE1 8NH|XE1 1RJ|XE1 1RN|XE1 1LE|XE24 99X|XE 0AA|XE12 8HJ)|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2}))$/i
};
/* eslint-enable max-len */

/* eslint-disable import/prefer-default-export */
export const isValidEmailAddress = (value) => !regexes.email.test(value);

export const isTel = (value) => !regexes.tel.test(value);

export const isValidMobile = (value) => !regexes.mobile.test(value);

export const isValidGlobalBehaviour = (value, type) => {
  if (!value) {
    return false;
  }
  const regExp = new RegExp(regexes[type]);
  return regExp.test(value);
};

/* eslint-disable import/prefer-default-export */
export const isOptionalGlobalBehaviour = (value, type) => {
  const regExp = new RegExp(regexes[type]);
  return regExp.test(value);
};

export const isValidType = (value) => {
  if (!value) {
    return false;
  }
  const { dateField, monthField, yearField } = value;
  const date = `${dateField}-${monthField}-${yearField}`;
  return isValidGlobalBehaviour(date, 'date');
};

export const isDateValid = (DateField = {}) => {
  const { dateField, monthField, yearField } = DateField;
  if (!dateField || !monthField || !yearField) {
    return false;
  }
  if (!isValidType(DateField)) {
    return false;
  }
  const date = moment(`${yearField}-${monthField}-${dateField}`, 'YYYY-MM-DD', true);
  if (moment().diff(date, 'days') > 0 || moment().diff(date, 'days') === 0) {
    return date.isValid();
  }
  return false;
};

export const isTradingLessThanSixMonths = (DateField = {}) => {
  const sixMonths = 6;
  const sixMonthsAgo = moment().startOf('days').subtract(sixMonths, 'months');
  const { dateField, monthField, yearField } = DateField;
  const tradingDuration = moment(`${dateField}-${monthField}-${yearField}`, 'DD-MM-YYYY', true);
  const tradingDateSixMonths = moment(tradingDuration, 'DD-MM-YYYY').isAfter(sixMonthsAgo);
  const tradingSameDate = moment(tradingDuration, 'DD-MM-YYYY').isSame(sixMonthsAgo);
  const tradingFormat = moment(
    `${dateField}-${monthField}-${yearField}`,
    'DD-MM-YYYY',
    true
  ).isValid();
  const daysInFuture = tradingDuration.diff(moment().add(1, 'days'), 'days');
  if (daysInFuture < 0 && (tradingDateSixMonths || tradingSameDate) && tradingFormat) {
    return true;
  }
  return false;
};

export const isSortCodeValid = (sortField = {}) => {
  const { sortField1, sortField2, sortField3 } = sortField;
  const sortFieldValid = `${sortField1}${sortField2}${sortField3}`;
  if (isValidGlobalBehaviour(sortFieldValid, 'sortCode')) {
    return true;
  }
  return false;
};
